import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class ClientOnboardingUserType {
  public readonly key = 'ClientOnboardingUserType';
  public readonly enrollTrackRole = EnrollTrackRole.ClientOnboarding;
}
